/* Premade3D theme behaviour. Progressive enhancement only: every flow (add to cart, remove, filters,
   sort, menu) also works as plain links and forms. Loaded with `defer`; no dependencies. */
(() => {
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => [...root.querySelectorAll(sel)];
  let config = { cartType: 'drawer', routes: { cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' }, strings: {} };
  try { config = { ...config, ...JSON.parse($('#ThemeConfig')?.textContent || '{}') }; } catch { /* keep defaults */ }
  const S = config.strings;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const fill = (text, vars) => String(text || '').replace(/\[(\w+)\]/g, (_, k) => vars[k] ?? '');

  /* ------------------------------------------------------------------ toast */
  let toastTimer;
  function clearCartNotice() {
    const notice = $('[data-cart-notice]');
    if (notice) notice.textContent = '';
  }
  function notify(text) {
    const t = $('#Toast');
    const notice = $('[data-cart-drawer][open] [data-cart-notice]');
    if (notice) {
      // Native dialogs make the page toast inert. Keep one persistent status in the active drawer.
      clearTimeout(toastTimer);
      if (t) { t.dataset.open = 'false'; t.textContent = ''; }
      if (notice.textContent !== String(text || '')) notice.textContent = String(text || '');
      return;
    }
    if (!t) return;
    t.textContent = text;
    t.dataset.open = 'true';
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { t.dataset.open = 'false'; }, 4200);
  }

  /* ------------------------------------------------------------------ cart state */
  let state = { count: 0, variants: [], products: [], covered: [] };
  function readState(root = document) {
    try { state = JSON.parse($('[data-cart-state]', root)?.textContent || '{}'); } catch { /* keep previous */ }
    state.variants = state.variants || [];
    state.products = state.products || [];
    state.lines = state.lines || [];
    state.covered = state.lines.flatMap(line => (line.contents || []).map(id => [id, line.title]));
    return state;
  }
  const coveredBy = productId => (state.covered.find(([id]) => String(id) === String(productId)) || [])[1];

  /* Keep the bundle dock steady across updates; only its changed contents animate. */
  let dockNode, dockVisible = false, dockSpace, dockResize;
  function positionBundleDock() {
    const dock = $('[data-bundle-dock]');
    if (!dock || !dockSpace) return;
    const visible = getComputedStyle(dock).display !== 'none' && Boolean($('.dock__row', dock));
    const header = $('.section-header') || $('.top');
    const top = Math.max(0, header?.getBoundingClientRect().bottom || 0) + 12;
    dock.style.setProperty('--bundle-dock-top', `${top}px`);
    const height = dock.getBoundingClientRect().height;
    dockSpace.style.setProperty('--bundle-dock-space', visible ? `${height + 24}px` : '0px');
    document.documentElement.style.setProperty('--bundle-scroll-offset', `${visible ? top + height + 12 : Math.max(88, top)}px`);
  }
  function syncBundleDock() {
    const dock = $('[data-bundle-dock]');
    const main = $('#MainContent');
    if (!dock || !main) return;
    if (!dockSpace) {
      dockSpace = document.createElement('div');
      dockSpace.className = 'bundle-dock-space';
      dockSpace.setAttribute('aria-hidden', 'true');
      main.before(dockSpace);
    }
    const changed = dock !== dockNode;
    dock.classList.add('dock--top');
    const visible = getComputedStyle(dock).display !== 'none' && Boolean($('.dock__row', dock));
    positionBundleDock();
    if (visible && !dockVisible && !reduceMotion.matches) {
      dock.classList.remove('dock--enter');
      void dock.offsetWidth;
      dock.classList.add('dock--enter');
    }
    if (changed && typeof ResizeObserver !== 'undefined') {
      dockResize?.disconnect();
      dockResize = new ResizeObserver(positionBundleDock);
      dockResize.observe(dock);
      const header = $('.section-header') || $('.top');
      if (header) dockResize.observe(header);
    }
    dockNode = dock;
    dockVisible = visible;
  }
  let dockScrollFrame;
  window.addEventListener('scroll', () => {
    if (dockScrollFrame) return;
    dockScrollFrame = requestAnimationFrame(() => { dockScrollFrame = null; positionBundleDock(); });
  }, { passive: true });
  window.addEventListener('resize', positionBundleDock);
  reduceMotion.addEventListener?.('change', () => {
    if (reduceMotion.matches) dockNode?.classList.remove('dock--enter');
  });

  function syncButtons() {
    $$('[data-cart-count]').forEach(el => {
      el.firstChild && (el.firstChild.nodeValue = String(state.count));
      el.hidden = !state.count;
    });
    $$('[data-quick-add]').forEach(btn => {
      const pid = btn.dataset.productId;
      const on = state.products.map(String).includes(String(pid)) || Boolean(coveredBy(pid));
      btn.setAttribute('aria-pressed', String(on));
      btn.disabled = pendingAdds.has(keyFor(btn.dataset.quickAdd, pid));
    });
    $$('[data-product-coverage]').forEach(notice => {
      const host = coveredBy(notice.dataset.productId);
      notice.hidden = !host;
      const label = $('[data-coverage-label]', notice);
      if (label) label.textContent = host ? fill(notice.dataset.template, { parent: host }) : '';
    });
    $$('[data-add-button]').forEach(btn => {
      const label = $('[data-label]', btn);
      const inCart = state.products.map(String).includes(String(btn.dataset.productId));
      const covered = Boolean(coveredBy(btn.dataset.productId));
      btn.hidden = covered;
      btn.disabled = covered || pendingAdds.has(keyFor(null, btn.dataset.productId));
      if (!btn.dataset.defaultLabel) btn.dataset.defaultLabel = label?.textContent || 'Add to cart';
      if (inCart) {
        if (label) label.textContent = S.inCart || 'In your cart';
        btn.dataset.inCart = 'true';
      } else {
        if (label) label.textContent = btn.dataset.defaultLabel;
        delete btn.dataset.inCart;
        btn.removeAttribute('formaction');
        btn.removeAttribute('formmethod');
      }
    });
    syncBundleDock();
  }

  /* ------------------------------------------------------------------ drawer */
  const drawer = () => $('[data-cart-drawer]');
  let opener = null;
  function showCart(trigger) {
    const d = drawer();
    if (!d || config.cartType === 'page') { window.location.href = config.routes.cart; return; }
    syncBundleDock();
    opener = trigger || document.activeElement;
    window.PM3DMotion?.openDrawer(d);
    if (!d.open) d.showModal();
    $('[data-close-cart]', d)?.focus();
  }
  let cartOpenRequest = null;
  function openCart(trigger) {
    if (!drawer() || config.cartType === 'page') { window.location.href = config.routes.cart; return Promise.resolve(); }
    if (cartOpenRequest) return cartOpenRequest;
    trigger?.setAttribute('aria-busy', 'true');
    cartOpenRequest = enqueueCart(async () => {
      await refreshCart();
      showCart(trigger);
    }).catch(err => { notify(err.message); }).finally(() => {
      trigger?.removeAttribute('aria-busy');
      cartOpenRequest = null;
    });
    return cartOpenRequest;
  }
  function closeCart() {
    const d = drawer();
    if (d?.open) {
      if (window.PM3DMotion) window.PM3DMotion.closeDrawer(d);
      else d.close();
    }
  }
  function restoreCartFocus() {
    // Section rendering can replace the bundle-review link while its dialog is open.
    const target = document.contains(opener) ? opener
      : $('[data-bundle-dock] [data-open-cart]') || $('[data-open-cart]');
    target?.focus();
  }
  document.addEventListener('close', e => {
    if (e.target === drawer()) {
      clearCartNotice();
      if (opener) restoreCartFocus();
    }
  }, true);

  function applySections(sections) {
    const html = sections?.['cart-drawer'];
    if (!html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const swap = sel => { const next = $(sel, doc); const cur = $(sel); if (next && cur) cur.replaceWith(next); };
    const hadFocus = drawer()?.contains(document.activeElement);
    const motionBefore = window.PM3DMotion?.captureCart();
    swap('[data-drawer-content]');
    swap('[data-bundle-dock]');
    swap('[data-cart-state]');
    readState();
    syncButtons();
    window.PM3DMotion?.updateCart(motionBefore);
    if (hadFocus) $('[data-close-cart]')?.focus();
  }

  async function cartRequest(url, body) {
    const res = await fetch(`${url}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ ...body, sections: 'cart-drawer', sections_url: config.routes.cart }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.description || data.message || S.error || 'Something went wrong.');
    cartMutationRevision++;
    return data;
  }

  // Serialize every enhanced cart mutation. Web Locks also coordinate this store's open tabs.
  let cartQueue = Promise.resolve();
  let cartMutationRevision = 0;
  const pendingAdds = new Set();
  const keyFor = (variant, product) => String(product || variant);
  const enqueueCart = operation => {
    const complete = async () => {
      clearCartNotice();
      const before = cartMutationRevision;
      const result = await operation();
      if (cartMutationRevision !== before) {
        // Read the final cart only after all overlap/quantity corrections have finished.
        // Measurement is optional and must never fail a successful shopping operation.
        try { Promise.resolve(window.PM3DCartOffers?.changed()).catch(() => {}); } catch { /* optional telemetry */ }
      }
      return result;
    };
    const run = () => navigator.locks?.request
      ? navigator.locks.request('premade3d-cart', complete) : complete();
    const task = cartQueue.then(run, run);
    cartQueue = task.catch(() => {});
    return task;
  };
  function setAddBusy(key, busy) {
    $$('[data-quick-add], [data-add-button]').forEach(button => {
      const variant = button.dataset.quickAdd || $('input[name="id"]', button.form)?.value;
      if (keyFor(variant, button.dataset.productId) !== key) return;
      if (busy) { button.setAttribute('aria-busy', 'true'); button.disabled = true; }
      else { button.removeAttribute('aria-busy'); button.disabled = Boolean(coveredBy(button.dataset.productId)); }
    });
  }
  async function refreshCart() {
    // Ask for the HTML route with section rendering. Accept: application/json makes /cart return
    // ordinary cart JSON instead, ignoring sections. Keep catalog pagination out of this URL.
    const response = await fetch(`${config.routes.cart}?sections=cart-drawer`, { headers: { Accept: 'text/html' }, cache: 'no-store' });
    if (!response.ok) throw new Error(S.error || 'Could not refresh your cart. Please try again.');
    const sections = await response.json();
    if (!sections['cart-drawer']) throw new Error(S.error || 'Could not refresh your cart. Please try again.');
    applySections(sections);
  }
  let cartReconcileRequest = null;
  function reconcileCart() {
    if (cartReconcileRequest) return cartReconcileRequest;
    cartReconcileRequest = enqueueCart(refreshCart).catch(err => {
      // An explicit drawer open always retries and reports failures. Background reads stay quiet
      // unless the cart is already being viewed.
      if (drawer()?.open) notify(err.message);
    }).finally(() => { cartReconcileRequest = null; });
    return cartReconcileRequest;
  }
  window.addEventListener('pageshow', e => {
    const navigation = window.performance?.getEntriesByType?.('navigation')[0];
    if (e.persisted || navigation?.type === 'back_forward') reconcileCart();
  });
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') reconcileCart();
  });
  window.addEventListener('focus', () => {
    if (document.visibilityState === 'visible') reconcileCart();
  });
  function cartCorrections(lines) {
    const seen = new Set();
    return lines.flatMap(line => {
      if (!line.digital) return [];
      const id = String(line.product);
      const host = lines.find(other => {
        if (String(other.product) === id) return false;
        const theirs = (other.contents || []).map(String);
        return theirs.includes(id);
      });
      const quantity = host || seen.has(id) ? 0 : 1;
      seen.add(id);
      return Number(line.quantity) === quantity ? [] : [{ key: line.key, quantity }];
    });
  }
  async function normalizeCart() {
    let changed = false;
    // Recompute after every change: Shopify may merge/rekey discounted lines.
    for (let attempt = 0; attempt < 100; attempt++) {
      const correction = cartCorrections(state.lines || [])[0];
      if (!correction) {
        if (changed) notify('Your cart now has one copy of each item. Items included in a collection or kit were removed.');
        return changed;
      }
      const data = await cartRequest(config.routes.cartChange, { id: correction.key, quantity: correction.quantity });
      if (!data.sections?.['cart-drawer']) throw new Error(S.error || 'Please refresh your cart before checkout.');
      applySections(data.sections);
      changed = true;
    }
    throw new Error('Please review your cart before checkout.');
  }
  async function addToCart(variantId, { productId, title, trigger } = {}) {
    const key = keyFor(variantId, productId);
    if (pendingAdds.has(key)) return;
    pendingAdds.add(key);
    setAddBusy(key, true);
    try {
      await enqueueCart(async () => {
        await refreshCart();
        await normalizeCart();
        if ((state.products || []).map(String).includes(String(productId)) ||
          (state.variants || []).map(String).includes(String(variantId))) { showCart(trigger); return; }
        const host = productId && coveredBy(productId);
        if (host) { notify(fill(S.covered, { title, parent: host })); return; }
        const data = await cartRequest(config.routes.cartAdd, { items: [{ id: Number(variantId), quantity: 1 }] });
        if (data.sections?.['cart-drawer']) applySections(data.sections);
        else await refreshCart();
        const normalized = await normalizeCart();
        if (config.cartType === 'page') { window.location.href = config.routes.cart; return; }
        if (trigger?.hasAttribute('data-add-button') && drawer()) showCart(trigger);
        else if (!normalized) notify(fill(S.added, { title }));
      });
    } catch (err) { notify(err.message); }
    finally { pendingAdds.delete(key); setAddBusy(key, false); syncButtons(); }
  }

  async function removeLine(key, trigger) {
    trigger?.setAttribute('aria-busy', 'true');
    try {
      await enqueueCart(async () => {
        const data = await cartRequest(config.routes.cartChange, { id: key, quantity: 0 });
        if (data.sections?.['cart-drawer']) applySections(data.sections);
        else await refreshCart();
        notify(S.removed);
        if (window.location.pathname.replace(/\/$/, '') === config.routes.cart) window.location.reload();
      });
    } catch (err) { notify(err.message); }
    finally { trigger?.removeAttribute('aria-busy'); }
  }

  let checkoutPending = false;
  document.addEventListener('submit', async e => {
    if (e.submitter?.name !== 'checkout' || !e.target.querySelector('[name="checkout"]')) return;
    e.preventDefault();
    if (checkoutPending) return;
    checkoutPending = true;
    const button = e.submitter;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    try {
      await enqueueCart(async () => {
        await refreshCart();
        const changed = await normalizeCart();
        if (changed) {
          if (window.location.pathname.replace(/\/$/, '') === config.routes.cart) window.location.reload();
          else showCart(button);
          return; // Review corrected totals before deliberately continuing.
        }
        window.location.assign(`${config.routes.cart}/checkout`);
      });
    } catch (err) { notify(err.message); }
    finally { checkoutPending = false; button.disabled = false; button.removeAttribute('aria-busy'); }
  });

  document.addEventListener('click', e => {
    const quick = e.target.closest('[data-quick-add]');
    if (quick) {
      e.preventDefault();
      if (quick.getAttribute('aria-pressed') === 'true') { openCart(quick); return; }
      addToCart(quick.dataset.quickAdd, { productId: quick.dataset.productId, title: quick.dataset.title, trigger: quick });
      return;
    }
    const remove = e.target.closest('[data-line-remove]');
    if (remove) {
      e.preventDefault();
      removeLine(remove.dataset.lineRemove, remove);
      return;
    }
    const inCartButton = e.target.closest('[data-add-button][data-in-cart]');
    if (inCartButton) { e.preventDefault(); openCart(inCartButton); return; }
    const openTrigger = e.target.closest('[data-open-cart]');
    if (openTrigger && drawer() && config.cartType !== 'page') { e.preventDefault(); openCart(openTrigger); return; }
    if (e.target.closest('[data-close-cart]')) { closeCart(); return; }
    const d = drawer();
    if (d && e.target === d) closeCart(); /* click on the backdrop */
  });

  document.addEventListener('submit', e => {
    const form = e.target.closest('form[data-product-form]');
    if (!form) return;
    const button = $('[data-add-button]', form);
    if (!button) return;
    e.preventDefault();
    if (button.dataset.inCart) { openCart(button); return; }
    addToCart(new FormData(form).get('id'), { productId: button.dataset.productId, title: button.dataset.title, trigger: button });
  });

  /* ------------------------------------------------------------------ header menu */
  document.addEventListener('click', e => {
    const toggle = e.target.closest('[data-menu-toggle]');
    if (toggle) {
      const nav = document.getElementById(toggle.getAttribute('aria-controls'));
      const open = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', String(open));
      if (nav) nav.dataset.open = String(open);
      return;
    }
    $$('[data-nav-disclosure][open]').forEach(d => { if (!d.contains(e.target)) d.open = false; });
  });
  document.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    $$('[data-nav-disclosure][open]').forEach(d => { d.open = false; $('summary', d)?.focus(); });
    const toggle = $('[data-menu-toggle][aria-expanded="true"]');
    if (toggle) { toggle.click(); toggle.focus(); }
  });

  /* ------------------------------------------------------------------ campaign strip */
  $$('[data-strip]').forEach(strip => {
    const track = $('[data-strip-track]', strip);
    const prev = $('[data-strip-prev]', strip);
    const next = $('[data-strip-next]', strip);
    if (!track || !prev || !next) return;
    prev.hidden = false;
    next.hidden = false;
    const sync = () => {
      prev.disabled = track.scrollLeft < 8;
      next.disabled = track.scrollLeft + track.clientWidth > track.scrollWidth - 8;
    };
    const go = dir => track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    prev.addEventListener('click', () => go(-1));
    next.addEventListener('click', () => go(1));
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync, { passive: true });
    sync();
  });

  /* ------------------------------------------------------------------ product gallery + 3D */
  const hasWebGL = () => {
    try {
      const c = document.createElement('canvas');
      return Boolean(window.WebGLRenderingContext && (c.getContext('webgl2') || c.getContext('webgl')));
    } catch { return false; }
  };
  function modelFallback(slide, message) {
    slide.dataset.loaded = 'failed';
    $('[data-load-model]', slide)?.remove();
    const hint = $('[data-model-hint]', slide);
    if (hint) hint.lastChild.nodeValue = message;
    $('model-viewer', slide)?.remove();
    const poster = $('[data-model-poster]', slide);
    if (poster) poster.hidden = false;
  }
  function loadModel(slide) {
    if (slide.dataset.loaded) return;
    if (!hasWebGL()) { modelFallback(slide, S.noWebgl); return; }
    const tpl = $('template[data-model-template]', slide);
    if (!tpl || !window.Shopify?.loadFeatures) { modelFallback(slide, S.modelError); return; }
    slide.dataset.loaded = 'loading';
    if (!document.getElementById('ModelViewerStyle')) {
      const link = Object.assign(document.createElement('link'), { id: 'ModelViewerStyle', rel: 'stylesheet', href: 'https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css' });
      document.head.append(link);
    }
    const viewer = tpl.content.firstElementChild.cloneNode(true);
    viewer.addEventListener('error', () => modelFallback(slide, S.modelError));
    viewer.addEventListener('load', () => { slide.dataset.loaded = 'ready'; });
    window.Shopify.loadFeatures([{
      name: 'model-viewer-ui',
      version: '1.0',
      onLoad: errors => {
        if (errors) { modelFallback(slide, S.modelError); return; }
        const poster = $('[data-model-poster]', slide);
        if (poster) poster.hidden = true;
        slide.prepend(viewer);
        try { new window.Shopify.ModelViewerUI(viewer); } catch { /* the viewer still orbits without the UI chrome */ }
        viewer.focus?.();
      },
    }]);
  }
  $$('[data-gallery]').forEach(gallery => {
    const slides = $$('[data-slide]', gallery);
    const thumbs = $$('[data-slide-target]', gallery);
    const show = i => {
      slides.forEach(s => { s.hidden = s.dataset.slide !== String(i); });
      thumbs.forEach(t => t.setAttribute('aria-pressed', String(t.dataset.slideTarget === String(i))));
      const slide = slides.find(s => s.dataset.slide === String(i));
      if (slide?.dataset.mediaType === 'model') loadModel(slide);
      $$('model-viewer', gallery).forEach(mv => { if (mv.closest('[hidden]')) mv.dismissPoster?.(); });
    };
    gallery.addEventListener('click', e => {
      const t = e.target.closest('[data-slide-target]');
      if (t) { show(t.dataset.slideTarget); return; }
      const load = e.target.closest('[data-load-model]');
      if (load) loadModel(load.closest('[data-slide]'));
    });
  });

  /* ------------------------------------------------------------------ filters and sorting */
  $$('[data-facet-form]').forEach(form => {
    let timer;
    form.addEventListener('change', e => {
      clearTimeout(timer);
      const delay = e.target.type === 'number' ? 600 : 0;
      timer = setTimeout(() => form.requestSubmit ? form.requestSubmit() : form.submit(), delay);
    });
    form.addEventListener('formdata', e => {
      // Omit empty bounds without disabling controls that survive in browser history.
      $$('input[type="number"]', form).forEach(i => { if (i.value === '') e.formData.delete(i.name); });
    });
    window.addEventListener('pagehide', () => clearTimeout(timer));
    window.addEventListener('pageshow', e => {
      const navigation = window.performance?.getEntriesByType?.('navigation')[0];
      if (!e.persisted && navigation?.type !== 'back_forward') return;
      clearTimeout(timer);
      // The cached results belong to the server-rendered defaults. Wait until the browser
      // finishes restoring form state, then restore those defaults, including the linked sort.
      timer = setTimeout(() => form.reset(), 0);
    });
  });
  // Search queries live outside the facet form; restore them to the same server-rendered
  // search on history navigation without touching edits during an ordinary page visit.
  $$('form[role="search"]').forEach(form => {
    let restoreTimer;
    window.addEventListener('pagehide', () => clearTimeout(restoreTimer));
    window.addEventListener('pageshow', e => {
      const navigation = window.performance?.getEntriesByType?.('navigation')[0];
      if (!e.persisted && navigation?.type !== 'back_forward') return;
      clearTimeout(restoreTimer);
      restoreTimer = setTimeout(() => form.reset(), 0);
    });
  });
  $$('[data-sort]').forEach(select => select.addEventListener('change', () => {
    const form = select.form;
    if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
    else {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.href = url.toString();
    }
  }));

  readState();
  syncButtons();
  /* ------------------------------------------------------------------ countdown (real end times only) */
  // Every timed surface owns its deadline, including cards without a visible clock. No page reload
  // or new deadline: suspended tabs reconcile from wall time as soon as they resume.
  const endOffer = el => {
    if (el.dataset.offerExpired === 'true') return;
    el.dataset.offerExpired = 'true';
    if (el.hasAttribute('data-offer-expire-hide')) el.hidden = true;
    $$('[data-offer-expire-hide], .offer-note, .deal-card__tag', el).forEach(n => { n.hidden = true; });
    $$('[data-offer-expire-show]', el).forEach(n => { n.hidden = false; });
    const replacements = [el, ...$$('[data-offer-expired-text]', el)];
    replacements.forEach(n => {
      if (n.dataset.offerExpiredText !== undefined) n.textContent = n.dataset.offerExpiredText;
    });
    if (el.dataset.offerSurface === 'price') {
      $$('s', el).forEach(n => { n.hidden = true; });
      const charged = $('[data-charged]', el);
      if (charged && el.dataset.listMoney) charged.textContent = el.dataset.listMoney;
    }
    // Neutralize the message without replacing its anchor or moving keyboard focus.
    if (el.hasAttribute('data-announce-item')) {
      el.dataset.kind = 'info';
      if (!el.hidden) el.closest('.announce')?.setAttribute('data-kind', 'info');
    }
  };
  const timerSelector = '[data-offer-until], [data-countdown]';
  // Preserve the conservative server correction used by the storefront. A clock behind the
  // response must never extend an offer. Monotonic elapsed time prevents backwards wall-clock
  // changes from resetting it; wall time catches up immediately after sleep/backgrounding.
  const initialWall = Date.now();
  const initialMono = performance.now();
  const serverAhead = Math.max(0, ...$$(timerSelector).map(el => (Number(el.dataset.serverNow) || 0) * 1000 - initialWall));
  const offerClockOffset = serverAhead > 5 * 6e4 ? serverAhead : 0;
  let lastOfferNow = initialWall + offerClockOffset;
  const offerNow = () => lastOfferNow = Math.max(lastOfferNow, Date.now() + offerClockOffset, initialWall + offerClockOffset + performance.now() - initialMono);
  const deadlineRecords = new WeakMap();
  const tickOffers = () => {
    const now = offerNow();
    $$(timerSelector).forEach(el => {
      const raw = el.dataset.offerUntil || el.dataset.countdown;
      let record = deadlineRecords.get(el);
      if (!record || record.raw !== raw) {
        record = { raw, end: Date.parse(raw) };
        deadlineRecords.set(el, record);
      }
      if (el.dataset.offerExpired === 'true') return;
      const left = record.end - now;
      if (!Number.isFinite(record.end) || left <= 0) {
        endOffer(el);
        if (el.hasAttribute('data-countdown')) {
          el.hidden = true;
          el.dispatchEvent(new CustomEvent('countdown:ended', { bubbles: true, detail: { phase: el.dataset.countdownPhase || 'end' } }));
        }
        return;
      }
      if (!el.hasAttribute('data-countdown')) return;
      el.classList.toggle('countdown--urgent', left < 864e5);
      const clock = $('[data-countdown-clock]', el);
      const pad = n => String(n).padStart(2, '0');
      const total = Math.ceil(left / 1000);
      const d = Math.floor(total / 86400), h = Math.floor(total / 3600) % 24, m = Math.floor(total / 60) % 60, s = total % 60;
      const text = `${d > 0 ? `${d}d ` : ''}${pad(h)}:${pad(m)}:${pad(s)}`;
      if (clock && clock.textContent !== text) clock.textContent = text;
    });
  };
  tickOffers();
  // One ticker covers existing and newly rendered Shopify/search/cart section contents.
  // No aria-live: second-by-second changes must not interrupt a screen reader.
  setInterval(tickOffers, 1000);
  new MutationObserver(records => {
    if (records.some(r => [...r.addedNodes].some(n => n.nodeType === 1 && (n.matches(timerSelector) || n.querySelector(timerSelector))))) tickOffers();
  }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('visibilitychange', tickOffers);
  window.addEventListener('pageshow', tickOffers);
  window.addEventListener('focus', tickOffers);

  /* ------------------------------------------------------------------ announcement rotation */
  const items = $$('[data-announce-item]');
  const announce = $('.announce');
  const dots = $$('[data-announce-dot]');
  if (items.length > 1 && announce) {
    let i = Math.max(0, items.findIndex(item => !item.hidden));
    let hovered = false;
    let finishSlide = null;
    reduceMotion.addEventListener('change', () => { if (reduceMotion.matches) finishSlide?.(); });
    let resumeAt = 0;
    const pause = () => { resumeAt = Date.now() + 5000; };
    announce.addEventListener('mouseenter', () => { hovered = true; });
    announce.addEventListener('mouseleave', () => { hovered = false; pause(); });
    announce.addEventListener('focusout', pause);
    setInterval(() => {
      if (reduceMotion.matches || document.hidden || hovered || announce.contains(document.activeElement) || Date.now() < resumeAt) return;
      finishSlide?.();
      tickOffers();
      items[i].hidden = true;
      i = (i + 1) % items.length;
      items[i].hidden = false;
      dots.forEach((dot, n) => { if (n === i) dot.setAttribute('data-on', ''); else dot.removeAttribute('data-on'); });
      const cta = $('[data-announce-cta]'); const link = items[i].querySelector('a');
      if (cta && link) cta.href = link.href;
      const incoming = items[i];
      if (!incoming.animate) {
        announce.dataset.kind = incoming.dataset.kind || 'new';
        return;
      }
      // Move the full-width incoming colour and its text on the same plane.
      // Keep the previous colour underneath until both animations finish.
      const background = document.createElement('span');
      background.className = 'announce__background';
      background.dataset.kind = incoming.dataset.kind || 'new';
      background.setAttribute('aria-hidden', 'true');
      announce.prepend(background);
      const frames = [{ transform: `translateY(-${announce.offsetHeight}px)` }, { transform: 'translateY(0)' }];
      const options = { duration: 350, easing: 'ease-out', fill: 'both' };
      const animations = [background.animate(frames, options), incoming.animate(frames, options)];
      const finish = () => {
        if (finishSlide !== finish) return;
        announce.dataset.kind = incoming.dataset.kind || 'new';
        finishSlide = null;
        background.remove();
        animations.forEach(animation => animation.cancel());
      };
      finishSlide = finish;
      animations[0].finished.then(finish, finish);
    }, 5000);
  }

  /* ------------------------------------------------------------------ sign-up gift popup and exit intent */
  // One dialog with two faces. Gift face: first visit after 20 s or half a page. Exit intent (desktop: pointer leaves
  // through the top; touch: a fast scroll back up after reading half the page): cart face when the cart has items,
  // gift face otherwise, once per session. Never after sign-up; a dismissal mutes it for 7 days. Never on campaign landings (the session flag is
  // set on any page view carrying utm_source or link_id, whether or not the popup renders there) or on offer pages.
  const session = { get(k) { try { return sessionStorage.getItem(k); } catch { return null; } }, set(k, v) { try { sessionStorage.setItem(k, v); } catch { /* private mode */ } } };
  try { const q = new URLSearchParams(location.search); if (q.has('utm_source') || q.has('link_id')) session.set('p3d_campaign_landing', '1'); } catch { /* no URL access */ }
  const popup = $('[data-offer-popup]');
  if (popup && typeof popup.showModal === 'function') {
    const store = { get(k) { try { return localStorage.getItem(k); } catch { return null; } }, set(k, v) { try { localStorage.setItem(k, v); } catch { /* private mode */ } } };
    // Visitors from a campaign link and offer pages get the offer, not a popup over it (spec: offer landing pages).
    const landingPage = document.querySelector('[data-offer-landing]')?.dataset.offerLanding || '';
    const campaign = () => session.get('p3d_campaign_landing') === '1';
    const membershipLanding = Boolean(document.querySelector('.membership-landing'));
    const week = 7 * 864e5;
    const subscribed = () => popup.dataset.posted === 'true';
    const subscriptionPending = () => Number(store.get('p3d_subscription_pending_until') || 0) > Date.now();
    const muted = () => Number(store.get('p3d_popup_muted_until') || 0) > Date.now();
    const mutePopup = () => { if (!muted()) store.set('p3d_popup_muted_until', String(Date.now() + week)); };
    popup.addEventListener('cancel', mutePopup);
    popup.addEventListener('close', mutePopup);
    const show = face => {
      if (popup.open || $('[data-cart-drawer][open]')) return;
      $$('[data-popup-face]', popup).forEach(f => { f.hidden = f.dataset.popupFace !== face; });
      const title = $(`[data-popup-face="${face}"] h2[id]`, popup);
      if (title) popup.setAttribute('aria-labelledby', title.id);
      popup.showModal();
    };
    if ($('[data-popup-success]', popup)) { store.set('p3d_subscription_pending_until', String(Date.now() + week)); if (!document.querySelector('.offer-signup')) show('gift'); }
    popup.addEventListener('click', e => {
      if (e.target.closest('[data-popup-close]') || e.target === popup) { mutePopup(); popup.close(); }
    });
    $('form', popup)?.addEventListener('submit', () => store.set('p3d_subscription_pending_until', String(Date.now() + week)));
    const giftOk = () => !campaign() && !membershipLanding && landingPage !== 'welcome-gift' && !subscribed() && !subscriptionPending() && !muted() && !session.get('p3d_popup_shown');
    const openGift = () => { if (giftOk()) { session.set('p3d_popup_shown', '1'); show('gift'); } };
    let timer = setTimeout(openGift, 20000);
    const halfway = () => window.scrollY + window.innerHeight >= document.documentElement.scrollHeight * 0.5;
    let maxY = 0, lastY = window.scrollY, lastT = Date.now();
    const exitIntent = () => {
      if (campaign() || membershipLanding || landingPage || session.get('p3d_exit_shown') || muted()) return;
      const face = state.count > 0 ? 'cart' : (subscribed() ? null : 'gift');
      if (!face) return;
      session.set('p3d_exit_shown', '1'); session.set('p3d_popup_shown', '1'); clearTimeout(timer);
      show(face);
    };
    window.addEventListener('scroll', () => {
      if (halfway()) { clearTimeout(timer); openGift(); }
      const y = window.scrollY, t = Date.now();
      maxY = Math.max(maxY, y);
      if (maxY > document.documentElement.scrollHeight * 0.5 && lastY - y > 600 && t - lastT < 400 && y < 400) exitIntent();
      lastY = y; lastT = t;
    }, { passive: true });
    document.addEventListener('mouseout', e => { if (!e.relatedTarget && e.clientY <= 0) exitIntent(); });
  }
})();
